import { object, string } from "yup";

import { LojaIntegradaAccountConnectionMessages } from "@/messages/platforms/lojaIntegradaConnection/lojaIntegrada-account-connection.messages";

import { LojaIntegradaAccountConnectionFormData } from "./types";

export const buildLojaIntegradaConnectionFormSchema = (
  messages: LojaIntegradaAccountConnectionMessages
) => {
  return object().shape({
    ApiKey: string().required(messages.errorRequiredApiKey),
  });
};

export const buildDefaultLojaIntegradaAccountConnectionFormData =
  (): LojaIntegradaAccountConnectionFormData => {
    return {
      ApiKey: "",
    };
  };
